import ShareSiHaDocumentationRequestModelBase from '../_generated/modelBases/share-si-ha-documentation-request-model-base';

export default class ShareSiHaDocumentationRequestModel extends ShareSiHaDocumentationRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
